export default function hash(s) {
	if (!s) {
		s = '';
	} else if (!s.split) {
		s = JSON.stringify(s);
	}
	return s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a;},0);
}



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/rawr/utils/hash.js
 **/